var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.6295 2.10584L15.9969 0.473215C15.366 -0.157738 14.3414 -0.157738 13.7083 0.473215L12.1444 2.0371L15.8053 5.69801L17.6295 3.87382C18.1189 3.38442 18.1189 2.59521 17.6295 2.10584ZM11.1907 2.98876L14.8516 6.64963L5.58484 15.9164L1.92601 12.2555L11.1907 2.98876ZM0.514153 17.8968C0.214278 17.9697 -0.0564364 17.701 0.0101874 17.4012L0.934789 13.2468L4.59362 16.9077L0.514153 17.8968Z",
    transform: "translate(3 3)",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    id: "artboard_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artboard_1",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Edit",
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6295 2.10584L15.9969 0.473215C15.366 -0.157738 14.3414 -0.157738 13.7083 0.473215L12.1444 2.0371L15.8053 5.69801L17.6295 3.87382C18.1189 3.38442 18.1189 2.59521 17.6295 2.10584ZM11.1907 2.98876L14.8516 6.64963L5.58484 15.9164L1.92601 12.2555L11.1907 2.98876ZM0.514153 17.8968C0.214278 17.9697 -0.0564364 17.701 0.0101874 17.4012L0.934789 13.2468L4.59362 16.9077L0.514153 17.8968Z",
    transform: "translate(3 3)",
    id: "Edit",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icon-Color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0L24 24L0 24L0 0Z",
    id: "Rectangle-13",
    fill: "#6200EE",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPrimary);
export default __webpack_public_path__ + "static/media/edit_primary.3a03e569933b53decda45e4d5c0cf055.svg";
export { ForwardRef as ReactComponent };